export enum SuspicionItemStatus {
  Pending = 'pending',
  Problem = 'problem',
  WrongTarget = 'wrong_target',
  NoProblem = 'no_problem',
}
